import { FC, useEffect, useState } from 'react'
import { ID, KTCard, KTCardBody, QUERIES } from '../../../../_dashboard/helpers'
import { PageDetailstoolbar } from './commun-component/PageDetailstoolbar'
import { PageDetailstoolbarSlider } from './commun-component/PageDetailstoolbarSlider'

import { Attribute, BlockComponent } from './commun-component/SectionComponent'
import { SliderComponent } from './commun-component/SliderComponent'

import { getOneById, getOneByIdbylang, updateOne } from '../../../services/common_requests'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { SectionEditModal } from './pages-details-edit-modal/SectionEditModal'
import { LanguageSelector } from './commun-component/LanguageSelector'
import { SliderEditModal } from './pages-details-edit-modal/SliderEditModal'
import { DetailPageBack } from '../../../../_dashboard/partials/components/DetailPageBack'

interface Section {
  _id: ID
  title: string
  position: number
  slider: Slider
  attributes: any[]
  translations: {
    language: string
    title: string
    subtitle: string
    content: string
  }[]
}
interface Slider {
  _id: string; 
  blockId: string; 
  name: string; 
  time: number; 
  items: string[]; 
  isActive: boolean; 
  __v: number; 
}
type Props = {
  id: ID
}

const PageInfo: FC<Props> = () => {
  const { id } = useParams<{ id: any }>()
  const [sections, setSections] = useState<Section[]>([])
  const [slider, setSlider] = useState<Slider[]>([])

  const [showSectionModal, setShowSectionModal] = useState(false)
  const handleCloseModal = () => {
    setShowSectionModal(false)
  }
  const [selectedLanguage, setSelectedLanguage] = useState('fr')

  const [selectedSectionId, setSelectedSectionId] = useState<ID | null>(null)
  const [selectedSectionIdSlider, setSelectedSectionIdSlider] = useState<ID | null>(null)

  const [forceRender, setForceRender] = useState(false)  // Add this line to define the state for force rendering

  const intl = useIntl()

  const handleAddSection = () => {
    setSelectedSectionId('new' as unknown as ID)
  }
  const handleAddSlider = () => { 
    setSelectedSectionIdSlider('new' as unknown as ID)
  }
  const { data: dataResponse } = useQuery(
    [QUERIES.SECTION_LIST, id, selectedLanguage],
    () => getOneByIdbylang(`/pages/${id}?language=${selectedLanguage}`),
    {
      refetchOnWindowFocus: false,
      enabled: !!id,
      retry: (failureCount, error: any) => {
        const status = error?.response?.status
        if (status === 401 || status === 403) return false
        return failureCount < 2
      },
    }
  )

  useEffect(() => {
    setSections(dataResponse?.blocks || [])
  }, [dataResponse])

  const handleAttributeAdded = (updatedBlockId: string, newAttribute: Attribute) => {
    setSections((prevSections) =>
        prevSections.map((section) =>
            String(section._id) === String(updatedBlockId)
                ? { 
                    ...section, 
                    attributes: [...section.attributes, { ...newAttribute }]
                }
                : section
        )
    )
    
  }

  const handleAttributeDeleted = (updatedBlockId: string, deletedAttributeId: string) => {
    setSections((prevSections) =>
        prevSections.map((section) =>
            String(section._id) === String(updatedBlockId)
                ? { 
                    ...section, 
                    attributes: section.attributes.filter(
                        (attr: Attribute) => String(attr._id) !== String(deletedAttributeId)
                    )
                }
                : section
        )
    );
};

  return (
    <>
      <ToastContainer />
      <DetailPageBack to='/apps/pages-management/pages' />
      <KTCard>
        <KTCardBody className='py-4'>
          <PageDetailstoolbarSlider onAddSlider={handleAddSlider} />
          {selectedSectionIdSlider !== null && (
            <SliderEditModal
              sectionId={selectedSectionIdSlider}
              pageId={id}
              onClose={() => setSelectedSectionIdSlider(null)}
            />
          )}
          {sections
            ?.filter(section => section.slider) 
            .map((section: Section) => (
            <SliderComponent 
              key={section._id} 
              block={section}
              pageId={id}
              selectedLanguage={selectedLanguage}
              handleAttributeAdded={handleAttributeAdded} 
              />
          ))}

          <LanguageSelector 
            selected={selectedLanguage}
            onChange={(lang) => setSelectedLanguage(lang)}
          />
          <PageDetailstoolbar onAddSection={handleAddSection} />
          {selectedSectionId !== null && (
            <SectionEditModal
              sectionId={selectedSectionId}
              pageId={id}
              onClose={() => setSelectedSectionId(null)}
            />
          )}
          {sections
          ?.filter(block => !block.slider)
          .map((section: Section) => (
            <BlockComponent 
              key={section._id} 
              block={section}
              pageId={id}
              selectedLanguage={selectedLanguage}
              handleAttributeAdded={handleAttributeAdded} 
              handleAttributeDeleted={handleAttributeDeleted}
              />
          ))}
        </KTCardBody>
      </KTCard>
    </>
  )
}

export { PageInfo }
